import styled from 'styled-components';

export const PaginatorContainer = styled.div`
  display: flex;
  height: 4px;
  background-color: rgba(241, 241, 241, 1);
  border-radius: 29px;
  width: 100%;
`;

export const ActiveIndicator = styled.div`
  height: 100%;
  border-radius: 29px;
  background-color: rgba(196, 196, 196, 1);
  transition: all 0.5s ease;
`;
